module.exports = __WEBPACK_EXTERNAL_MODULE_76__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/text/TextFormat","root":["openfl","text","TextFormat"],"commonjs":"openfl/text/TextFormat","commonjs2":"openfl/text/TextFormat"}
// module id = 76
// module chunks = 0